import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { Formik, Field, Form } from 'formik';

import CrossIcon from 'assets/CrossIcon';
import SearchIcon from 'assets/SearchIcon';

import { SecondaryButton } from 'components/Buttons';

import colors from 'styles/colors';
import { INPUT_STYLES_MIXIN } from 'styles/form';

const SearchContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
`;

const StyledInput = styled(Field)`
  ${INPUT_STYLES_MIXIN}
  ${(props) => (props.$withSearchButton ? 'border-right: none;' : '')}
  font-size: 12px;
  border-radius: ${(props) => (props.$withSearchButton ? `4px 0px 0px 4px` : '4px')};
  width: ${(props) => (props.$withSearchButton ? 240 : 280)}px;
  ${(props) => (props.$clearShown ? 'padding: 5px 40px;' : 'padding: 5px 5px 5px 40px;')}
  &:focus {
    border-color: ${colors.blue};
  }
`;

const ClearButton = styled.button`
  border: none;
  position: absolute;
  right: 0;
`;

const StyledSearchIcon = styled(SearchIcon)`
  position: absolute;
  left: 10px;
`;

const SearchButton = styled(SecondaryButton)`
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;

  &[disabled] {
    border: 1px ${colors.fleetOffGray} solid;
  }
`;

const StyledForm = styled(Form)`
  display: flex;
`;

const SearchV2 = ({ defaultValue = '', placeholder = '', id, ...props }) => {
  const intl = useIntl();

  const handleClear = (event) => {
    if (props.onClear) {
      props.onClear(event);
    }
  };

  const handleSubmit = (event, formikBag) => {
    if (props.onSubmit) {
      props.onSubmit(event.search);
    }

    formikBag.setSubmitting(false);
  };

  const onChange = (event, formikHandleChange) => {
    formikHandleChange(event);
    if (event.target.value === '' && props.onClear) {
      props.onClear(event);
    } else if (props.onChange) {
      props.onChange(event.target.value);
    }
  };

  return (
    <Formik
      initialValues={{
        search: defaultValue,
      }}
      onSubmit={handleSubmit}
      onReset={handleClear}
    >
      {({ isSubmitting, handleChange, values }) => (
        <StyledForm className={props.className}>
          <SearchContainer>
            <StyledSearchIcon size={20} />
            <StyledInput
              id={id}
              name="search"
              type="text"
              aria-label="search"
              placeholder={placeholder}
              onChange={(event) => onChange(event, handleChange)}
              $withSearchButton={!props.onChange}
              $clearShown={Boolean(values.search)}
            />
            {values.search && (
              <ClearButton aria-label="clear" type="reset">
                <CrossIcon color={colors.fleetBlack} />
              </ClearButton>
            )}
          </SearchContainer>
          {!props.onChange && (
            <SearchButton type="submit" disabled={isSubmitting}>
              {intl.formatMessage({ id: 'search.label' }).toUpperCase()}
            </SearchButton>
          )}
        </StyledForm>
      )}
    </Formik>
  );
};

export default SearchV2;
